import React, { Component } from 'react';
import SystemStatusService from 'services/systemStatusService.js';
import { Dropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Moment from 'moment';

export default class StatusItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      created: this.props.created,
      status: this.props.status
    };
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
  }

  forceUpdateHandler = async (id) => {
    const result = await SystemStatusService.API.getSystemStatusById(id);
    if (result != null) {
      //var newvals = [{
      //  value: result.infoValue,
      //  created: result.created,
      //  status: result.status
      // }];
      //this.setState(newvals);
      await new Promise((resolve) =>
        this.setState(
          {
            value: result.infoValue,
            created: result.created,
            status: result.status
          },
          () => resolve()
        )
      );

      this.forceUpdate();
    }
  };

  render() {
    return (
      <div className={`status-item status-item-${this.state.status} rounded shadow border border-secondary`}>
        <StatusDropdown title='a'>
          <StatusDropdownItem onClick={() => this.forceUpdateHandler(this.props.typeId)}>Refresh Now</StatusDropdownItem>
        </StatusDropdown>
        <div className='status-content'>
          <LinkContainer to={this.props.to} className='status-value'>
            <a href={this.props.to}>{this.state.value}</a>
          </LinkContainer>
          <div className='status-title'>{this.props.title}</div>
          <div className='status-time'>{Moment(this.state.created).format('MM/DD/YYYY h:mma')}</div>
        </div>
      </div>
    );
  }
}

function StatusButton(items) {
  return (
    <button className='status-button' onClick={items.onClick}>
      <i className='icons8-more' />
    </button>
  );
}

function StatusDropdown(items) {
  const children = React.Children.toArray(items.children);
  if (children.length > 0) {
    return (
      <Dropdown alignRight>
        <Dropdown.Toggle as={StatusButton} {...items}>
          {items.title}
        </Dropdown.Toggle>
        <Dropdown.Menu>{items.children}</Dropdown.Menu>
      </Dropdown>
    );
  }
  else {
    return null;
  }
}

function StatusDropdownItem(items) {
  return <Dropdown.Item {...items}>{items.children}</Dropdown.Item>;
}
